<!-- 
	OptinFormTickets
	props: User
  	role: User
	Called by @/components/EmailVerificationComponent to allow user to register/create account
	Does include ticket package options
-->

<template>
  <div class="optin-form text-white">
    <div
      id="divForm_DIForm_709_18526"
      class="DialogInsightFormDiv"
      style="display: none"
    >
      <a name="divForm_DIForm_709_18526_globalErrors_anchor" />
      <div
        id="divForm_DIForm_709_18526_globalErrors"
        class="DialogInsightGlobalErrors"
      />
      <div class="DialogInsightFormContainer">
        <div class="DialogInsightLabel_AboveField cat-title">
          Dual Ticket Pack Bundles
        </div>
        <div
          class="form-row flex flex-col sm:flex-row justify-center my-0 sm:my-8 packages"
        >
          <div
            class="ticket-select cursor-pointer"
            @click="maxChange()"
          >
            <div class="package-cont">
              <img
                src="@/assets/MAX-CHANCE.png"
                class="package-image mb-4"
                alt=""
              >
            </div>
            <div class="main-label">
              Max Chance
            </div>
            <div class="small-label">
              <span class="font-bold">Main Draw</span> 40 Tickets for $40
            </div>
            <div class="small-label">
              <span class="font-bold">Quarterly Cash 50/50</span> 35 Tickets for
              $35
            </div>
          </div>
          <div
            class="ticket-select cursor-pointer"
            @click="highFive()"
          >
            <div class="package-cont">
              <img
                src="@/assets/HIGH-5.png"
                class="package-image mb-4"
                alt=""
              >
            </div>
            <div class="main-label">
              High Five
            </div>
            <div class="small-label">
              <span class="font-bold">Main Draw</span> 15 Tickets for $30
            </div>
            <div class="small-label">
              <span class="font-bold">Quarterly Cash 50/50</span> 16 Tickets for
              $25
            </div>
          </div>
          <div
            class="ticket-select cursor-pointer"
            @click="bigFour()"
          >
            <div class="package-cont">
              <img
                src="@/assets/THE-BIG-4-0.png"
                class="package-image mb-4"
                alt=""
              >
            </div>
            <div class="main-label">
              Big 4-0
            </div>
            <div class="small-label">
              <span class="font-bold">Main Draw</span> 15 Tickets for $30
            </div>
            <div class="small-label">
              <span class="font-bold">Quarterly Cash 50/50</span> 4 Tickets for
              $10
            </div>
          </div>
          <div
            class="ticket-select cursor-pointer"
            @click="easyTwenty()"
          >
            <div class="package-cont">
              <img
                src="@/assets/EASY-20.png"
                class="package-image mb-4"
                alt=""
              >
            </div>
            <div class="main-label">
              Easy 20
            </div>
            <div class="small-label">
              <span class="font-bold">Main Draw</span> 3 Tickets for $10
            </div>
            <div class="small-label">
              <span class="font-bold">Quarterly Cash 50/50</span> 4 Tickets for
              $10
            </div>
          </div>
          <div
            class="ticket-select cursor-pointer"
            @click="quickPick()"
          >
            <div class="package-cont">
              <img
                src="@/assets/QUICK-PACK.png"
                class="package-image mb-4"
                alt=""
              >
            </div>
            <div class="main-label">
              Quick Pack
            </div>
            <div class="small-label">
              <span class="font-bold">Main Draw</span> Single Ticket for $5
            </div>
            <div class="small-label">
              <span class="font-bold">Quarterly Cash 50/50</span> Single Ticket
              for $5
            </div>
          </div>
        </div>
        <div class="DialogInsightFormRow">
          <div class="DialogInsightLabel_AboveField cat-title">
            Select Your New Main Ticket Package
          </div>
          <div class="DialogInsightInputContainer">
            <div
              id="DIField_18526_f_NewMainTicketPackage"
              class="flex flex-col sm:flex-row justify-center my-0 sm:my-8"
            >
              <div class="ticket-select">
                <input
                  id="DIField_18526_f_NewMainTicketPackage4"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_NewMainTicketPackage"
                  value="40"
                >
                <label for="DIField_18526_f_NewMainTicketPackage4"><br><span class="main-label">Sets of 40 tickets for $40</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
              </div>
              <div class="ticket-select">
                <input
                  id="DIField_18526_f_NewMainTicketPackage3"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_NewMainTicketPackage"
                  value="30"
                >
                <label for="DIField_18526_f_NewMainTicketPackage3"><br><span class="main-label">Sets of 15 tickets for $30</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
              </div>
              <div class="ticket-select">
                <input
                  id="DIField_18526_f_NewMainTicketPackage2"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_NewMainTicketPackage"
                  value="20"
                >
                <label for="DIField_18526_f_NewMainTicketPackage2"><br><span class="main-label">Sets of 8 tickets for $20</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
              </div>
              <div class="ticket-select">
                <input
                  id="DIField_18526_f_NewMainTicketPackage1"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_NewMainTicketPackage"
                  value="10"
                >
                <label for="DIField_18526_f_NewMainTicketPackage1"><br><span class="main-label">Sets of 3 tickets for $10</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
              </div>
              <div class="ticket-select">
                <input
                  id="DIField_18526_f_NewMainTicketPackage0"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_NewMainTicketPackage"
                  value="5"
                >
                <label for="DIField_18526_f_NewMainTicketPackage0"><br><span class="main-label">Single Ticket for $5</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
              </div>
              <div
                id="DIField_18526_f_NewMainTicketPackage_errors"
                class="DialogInsightErrorContainer"
              />
            </div>
          </div>
          <div class="DialogInsightFormRow">
            <div class="DialogInsightLabel_AboveField cat-title">
              Select Your New 50/50 Ticket Package
            </div>
            <div class="DialogInsightInputContainer">
              <div
                id="DIField_18526_f_New5050TicketPackage"
                class="flex flex-col sm:flex-row justify-center my-0 sm:my-8"
              >
                <div class="ticket-select">
                  <input
                    id="DIField_18526_f_New5050TicketPackage3"
                    type="radio"
                    class="DialogInsightFormInput"
                    name="DIField_18526_f_New5050TicketPackage"
                    value="35"
                  >
                  <label for="DIField_18526_f_New5050TicketPackage3"><br><span class="main-label">Sets of 35 tickets for $35</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
                </div>
                <div class="ticket-select">
                  <input
                    id="DIField_18526_f_New5050TicketPackage2"
                    type="radio"
                    class="DialogInsightFormInput"
                    name="DIField_18526_f_New5050TicketPackage"
                    value="25"
                  >
                  <label for="DIField_18526_f_New5050TicketPackage2"><br><span class="main-label">Sets of 16 tickets for $25</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
                </div>
                <div class="ticket-select">
                  <input
                    id="DIField_18526_f_New5050TicketPackage1"
                    type="radio"
                    class="DialogInsightFormInput"
                    name="DIField_18526_f_New5050TicketPackage"
                    value="10"
                  >
                  <label for="DIField_18526_f_New5050TicketPackage1"><br><span class="main-label">Sets of 4 tickets for $10</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
                </div>
                <div class="ticket-select">
                  <input
                    id="DIField_18526_f_New5050TicketPackage0"
                    type="radio"
                    class="DialogInsightFormInput"
                    name="DIField_18526_f_New5050TicketPackage"
                    value="5"
                  >
                  <label for="DIField_18526_f_New5050TicketPackage0"><br><span class="main-label">Single Ticket for $5</span><br><span class="small-label">Deducted from Each Pay Period</span></label>
                </div>
              </div>
              <div
                id="DIField_18526_f_New5050TicketPackage_errors"
                class="DialogInsightErrorContainer"
              />
            </div>
          </div>
          <div class="DialogInsightLabel_AboveField cat-title">
            Your Account Information
          </div>
          <div class="flex flex-col sm:flex-row justify-center my-0 sm:my-8">
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_EmployeeID"
                  type="text"
                  class="DialogInsightFormInput"
                  placeholder="Employee ID"
                  maxlength="8"
                  :value="user.additionalData.employeeId"
                  readonly
                >
                <div
                  id="DIField_18526_f_EmployeeID_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_FirstName"
                  type="text"
                  class="DialogInsightFormInput"
                  placeholder="First Name"
                  :value="user.additionalData.firstName"
                  maxlength="50"
                  readonly
                >
                <div
                  id="DIField_18526_f_FirstName_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_LastName"
                  type="text"
                  class="DialogInsightFormInput"
                  :value="user.additionalData.lastName"
                  placeholder="Last Name"
                  maxlength="50"
                  readonly
                >
                <div
                  id="DIField_18526_f_LastName_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row justify-center my-0 sm:my-8">
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_HomeAddress"
                  type="text"
                  class="DialogInsightFormInput"
                  placeholder="Address"
                >
                <div
                  id="DIField_18526_f_HomeAddress_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_City"
                  type="text"
                  class="DialogInsightFormInput"
                  placeholder="City"
                  maxlength="50"
                >
                <div
                  id="DIField_18526_f_City_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_PostalCode"
                  type="text"
                  class="DialogInsightFormInput"
                  oninput="this.value = this.value.toUpperCase()"
                  placeholder="Postal Code"
                  maxlength="6"
                >
                <div
                  id="DIField_18526_f_PostalCode_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row justify-center my-0 sm:my-8">
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_MobilePhone"
                  v-model="mobilePhone"
                  type="text"
                  class="DialogInsightFormInput email-input"
                  placeholder="Mobile Phone "
                  minlength="10"
                  maxlength="10"
                >
                <div
                  id="DIField_18526_f_MobilePhone_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_HomePhone"
                  v-model="homePhone"
                  type="text"
                  class="DialogInsightFormInput email-input"
                  placeholder="Home Phone"
                  minlength="10"
                  maxlength="10"
                >
                <div
                  id="DIField_18526_f_HomePhone_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row justify-center my-0 sm:my-8">
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_EMail"
                  type="text"
                  class="DialogInsightFormInput email-input"
                  placeholder="Email "
                  :value="user.data.email"
                  maxlength="125"
                  readonly
                >
                <div
                  id="DIField_18526_f_EMail_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
            <div class="DialogInsightFormRow">
              <div class="DialogInsightInputContainer">
                <input
                  id="DIField_18526_f_AlternateEmail"
                  type="text"
                  class="DialogInsightFormInput email-input"
                  placeholder="Alternate Email"
                  maxlength="125"
                >
                <div
                  id="DIField_18526_f_AlternateEmail_errors"
                  class="DialogInsightErrorContainer"
                />
              </div>
            </div>
          </div>
          <div class="DialogInsightFormRow">
            <div class="DialogInsightLabel_AboveField cat-title">
              Payroll Selection
            </div>
            <div class="DialogInsightInputContainer payroll-select">
              <div id="DIField_18526_f_PayrollSelection">
                <input
                  id="DIField_18526_f_PayrollSelection0"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_PayrollSelection"
                  value="CHR"
                >
                <label for="DIField_18526_f_PayrollSelection0">Alberta Health Services</label>
                <br>
                <input
                  id="DIField_18526_f_PayrollSelection1"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_PayrollSelection"
                  value="CW"
                >
                <label for="DIField_18526_f_PayrollSelection1">Carewest</label>
                <br>
                <input
                  id="DIField_18526_f_PayrollSelection2"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_PayrollSelection"
                  value="COV"
                >
                <label for="DIField_18526_f_PayrollSelection2">Covenant Health</label>
                <br>
                <input
                  id="DIField_18526_f_PayrollSelection3"
                  type="radio"
                  class="DialogInsightFormInput"
                  name="DIField_18526_f_PayrollSelection"
                  value="LAB"
                >
                <label for="DIField_18526_f_PayrollSelection3">Alberta Precision Labs</label>
                <br>
              </div>
              <div
                id="DIField_18526_f_PayrollSelection_errors"
                class="DialogInsightErrorContainer"
              />
            </div>
          </div>
          <div class="DialogInsightFormRow designation">
            <div class="DialogInsightLabel_AboveField">
              Lottery Proceeds Beneficiary
            </div>
            <div class="DialogInsightInputContainer">
              <select
                id="DIField_18526_f_NewDesignation"
                class="DialogInsightFormInput"
              >
                <option
                  value="Addiction Services across Northern Alberta                  "
                  style="color: #000000;"
                >
                  Addiction Services across Northern Alberta
                </option>
                <option
                  value="Airdrie Community Health Centre                             "
                  style="color: #000000;"
                >
                  Airdrie Community Health Centre
                </option>
                <option
                  value="Alberta Children’s Hospital                                 "
                  style="color: #000000;"
                >
                  Alberta Children’s Hospital
                </option>
                <option
                  value="Alberta Hospital, Edmonton                                  "
                  style="color: #000000;"
                >
                  Alberta Hospital, Edmonton
                </option>
                <option
                  value="Alberta Women&#39;s Health Foundation                           "
                  style="color: #000000;"
                >
                  Alberta Women&#39;s Health Foundation
                </option>
                <option
                  value="Anzac Community Clinic                                      "
                  style="color: #000000;"
                >
                  Anzac Community Clinic
                </option>
                <option
                  value="Banff Mineral Springs Hospital (Banff)                      "
                  style="color: #000000;"
                >
                  Banff Mineral Springs Hospital (Banff)
                </option>
                <option
                  value="Barrhead Community Cancer Centre                            "
                  style="color: #000000;"
                >
                  Barrhead Community Cancer Centre
                </option>
                <option
                  value="Bassano Health Centre                                       "
                  style="color: #000000;"
                >
                  Bassano Health Centre
                </option>
                <option
                  value="Beaumont Public Health Centre                               "
                  style="color: #000000;"
                >
                  Beaumont Public Health Centre
                </option>
                <option
                  value="Beaverlodge Municipal Hospital                              "
                  style="color: #000000;"
                >
                  Beaverlodge Municipal Hospital
                </option>
                <option
                  value="Big Country Hospital                                        "
                  style="color: #000000;"
                >
                  Big Country Hospital
                </option>
                <option
                  value="Bonnyville Community Cancer Centre                          "
                  style="color: #000000;"
                >
                  Bonnyville Community Cancer Centre
                </option>
                <option
                  value="Bonnyville Health Centre                                    "
                  style="color: #000000;"
                >
                  Bonnyville Health Centre
                </option>
                <option
                  value="Bow Valley Community Cancer Centre                          "
                  style="color: #000000;"
                >
                  Bow Valley Community Cancer Centre
                </option>
                <option
                  value="Brooks Community Health/Home Care                           "
                  style="color: #000000;"
                >
                  Brooks Community Health/Home Care
                </option>
                <option
                  value="Brooks Health Centre                                        "
                  style="color: #000000;"
                >
                  Brooks Health Centre
                </option>
                <option
                  value="Calgary Community Health Centres                            "
                  style="color: #000000;"
                >
                  Calgary Community Health Centres
                </option>
                <option
                  value="Calgary Health Centres (SMCHC, SCHC, ECHC, RRDTC)           "
                  style="color: #000000;"
                >
                  Calgary Health Centres (SMCHC, SCHC, ECHC, RRDTC)
                </option>
                <option
                  value="Camrose Community Cancer Centre                             "
                  style="color: #000000;"
                >
                  Camrose Community Cancer Centre
                </option>
                <option
                  value="Cancer Control Alberta                                      "
                  style="color: #000000;"
                >
                  Cancer Control Alberta
                </option>
                <option
                  value="Canmore General Hospital                                    "
                  style="color: #000000;"
                >
                  Canmore General Hospital
                </option>
                <option
                  value="Cardston Health Centre                                      "
                  style="color: #000000;"
                >
                  Cardston Health Centre
                </option>
                <option
                  value="Carewest                                                    "
                  style="color: #000000;"
                >
                  Carewest
                </option>
                <option
                  value="Central Alberta Cancer Centre (Red Deer)                    "
                  style="color: #000000;"
                >
                  Central Alberta Cancer Centre (Red Deer)
                </option>
                <option
                  value="CK Hui Heart Centre                                         "
                  style="color: #000000;"
                >
                  CK Hui Heart Centre
                </option>
                <option
                  value="Claresholm Centre for Mental Health and Addictions          "
                  style="color: #000000;"
                >
                  Claresholm Centre for Mental Health and Addictions
                </option>
                <option
                  value="Claresholm General Hospital (CGH)                           "
                  style="color: #000000;"
                >
                  Claresholm General Hospital (CGH)
                </option>
                <option
                  value="Claresholm Mental Health Clinic                             "
                  style="color: #000000;"
                >
                  Claresholm Mental Health Clinic
                </option>
                <option
                  value="Community Health - Claresholm Health Unit                   "
                  style="color: #000000;"
                >
                  Community Health - Claresholm Health Unit
                </option>
                <option
                  value="Conklin Community Clinic                                    "
                  style="color: #000000;"
                >
                  Conklin Community Clinic
                </option>
                <option
                  value="Coronation Hospital &amp; Care Centre                           "
                  style="color: #000000;"
                >
                  Coronation Hospital &amp; Care Centre
                </option>
                <option
                  value="Cross Cancer Institute                                      "
                  style="color: #000000;"
                >
                  Cross Cancer Institute
                </option>
                <option
                  value="Crowsnest Pass Health Centre                                "
                  style="color: #000000;"
                >
                  Crowsnest Pass Health Centre
                </option>
                <option
                  value="Daysland Health Centre                                      "
                  style="color: #000000;"
                >
                  Daysland Health Centre
                </option>
                <option
                  value="Devon General Hospital                                      "
                  style="color: #000000;"
                >
                  Devon General Hospital
                </option>
                <option
                  value="Didsbury District Health Services                           "
                  style="color: #000000;"
                >
                  Didsbury District Health Services
                </option>
                <option
                  value="Drayton Valley Community Cancer Centre                      "
                  style="color: #000000;"
                >
                  Drayton Valley Community Cancer Centre
                </option>
                <option
                  value="Drumheller Community Cancer Centre                          "
                  style="color: #000000;"
                >
                  Drumheller Community Cancer Centre
                </option>
                <option
                  value="Drumheller Health Centre                                    "
                  style="color: #000000;"
                >
                  Drumheller Health Centre
                </option>
                <option
                  value="Edmonton General Continuing Care Centre                     "
                  style="color: #000000;"
                >
                  Edmonton General Continuing Care Centre
                </option>
                <option
                  value="Elnora Health Centre                                        "
                  style="color: #000000;"
                >
                  Elnora Health Centre
                </option>
                <option
                  value="Emergency Medical Services (EMS) Foundation – Calgary       "
                  style="color: #000000;"
                >
                  Emergency Medical Services (EMS) Foundation – Calgary
                </option>
                <option
                  value="Eye Institute of Alberta                                    "
                  style="color: #000000;"
                >
                  Eye Institute of Alberta
                </option>
                <option
                  value="Fairview Health Complex                                     "
                  style="color: #000000;"
                >
                  Fairview Health Complex
                </option>
                <option
                  value="Fairview Homecare                                           "
                  style="color: #000000;"
                >
                  Fairview Homecare
                </option>
                <option
                  value="Foothills Medical Centre                                    "
                  style="color: #000000;"
                >
                  Foothills Medical Centre
                </option>
                <option
                  value="Fort Macleod Health Centre                                  "
                  style="color: #000000;"
                >
                  Fort Macleod Health Centre
                </option>
                <option
                  value="Fort McKay Health Centre                                    "
                  style="color: #000000;"
                >
                  Fort McKay Health Centre
                </option>
                <option
                  value="Fort McMurray Community Cancer Centre                       "
                  style="color: #000000;"
                >
                  Fort McMurray Community Cancer Centre
                </option>
                <option
                  value="Fort McMurray Queens Street Mental Health                   "
                  style="color: #000000;"
                >
                  Fort McMurray Queens Street Mental Health
                </option>
                <option
                  value="Fort McMurray Recovery Centre                               "
                  style="color: #000000;"
                >
                  Fort McMurray Recovery Centre
                </option>
                <option
                  value="Fort McMurray Timberlea Mental Health Centre                "
                  style="color: #000000;"
                >
                  Fort McMurray Timberlea Mental Health Centre
                </option>
                <option
                  value="Fort Saskatchewan Community Hospital                        "
                  style="color: #000000;"
                >
                  Fort Saskatchewan Community Hospital
                </option>
                <option
                  value="Glenrose Rehabilitation Hospital                            "
                  style="color: #000000;"
                >
                  Glenrose Rehabilitation Hospital
                </option>
                <option
                  value="Grande Prairie Cancer Centre                                "
                  style="color: #000000;"
                >
                  Grande Prairie Cancer Centre
                </option>
                <option
                  value="Grande Prairie Regional Hospital                            "
                  style="color: #000000;"
                >
                  Grande Prairie Regional Hospital
                </option>
                <option
                  value="Grey Nuns Hospital                                          "
                  style="color: #000000;"
                >
                  Grey Nuns Hospital
                </option>
                <option
                  value="Grimshaw/Berwyn Community Health Care Centre                "
                  style="color: #000000;"
                >
                  Grimshaw/Berwyn Community Health Care Centre
                </option>
                <option
                  value="Hardisty Health Centre                                      "
                  style="color: #000000;"
                >
                  Hardisty Health Centre
                </option>
                <option
                  value="High River Communuty Cancer Centre                          "
                  style="color: #000000;"
                >
                  High River Communuty Cancer Centre
                </option>
                <option
                  value="High River General Hospital                                 "
                  style="color: #000000;"
                >
                  High River General Hospital
                </option>
                <option
                  value="High River Health Unit                                      "
                  style="color: #000000;"
                >
                  High River Health Unit
                </option>
                <option
                  value="Hinton Community Cancer Centre                              "
                  style="color: #000000;"
                >
                  Hinton Community Cancer Centre
                </option>
                <option
                  value="Hinton Healthcare Centre                                    "
                  style="color: #000000;"
                >
                  Hinton Healthcare Centre
                </option>
                <option
                  value="Hythe Continuing Care Centre                                "
                  style="color: #000000;"
                >
                  Hythe Continuing Care Centre
                </option>
                <option
                  value="Jack Ady Cancer Centre (Lethbridge)                         "
                  style="color: #000000;"
                >
                  Jack Ady Cancer Centre (Lethbridge)
                </option>
                <option
                  value="Kaye Edmonton Clinic                                        "
                  style="color: #000000;"
                >
                  Kaye Edmonton Clinic
                </option>
                <option
                  value="Killam Health Centre                                        "
                  style="color: #000000;"
                >
                  Killam Health Centre
                </option>
                <option
                  value="Lac La Biche Healthcare Centre                              "
                  style="color: #000000;"
                >
                  Lac La Biche Healthcare Centre
                </option>
                <option
                  value="Lacombe Hospital and Care Centre                            "
                  style="color: #000000;"
                >
                  Lacombe Hospital and Care Centre
                </option>
                <option
                  value="Lander Treatment Centre                                     "
                  style="color: #000000;"
                >
                  Lander Treatment Centre
                </option>
                <option
                  value="Leduc Community Hospital                                    "
                  style="color: #000000;"
                >
                  Leduc Community Hospital
                </option>
                <option
                  value="Leduc Public Health Centre                                  "
                  style="color: #000000;"
                >
                  Leduc Public Health Centre
                </option>
                <option
                  value="Lloydminster Community Cancer Centre                        "
                  style="color: #000000;"
                >
                  Lloydminster Community Cancer Centre
                </option>
                <option
                  value="Lois Hole Hospital for Women                                "
                  style="color: #000000;"
                >
                  Lois Hole Hospital for Women
                </option>
                <option
                  value="Manning Community Health Centre                             "
                  style="color: #000000;"
                >
                  Manning Community Health Centre
                </option>
                <option
                  value="Margery E. Yuill Cancer Centre (Medicine Hat)               "
                  style="color: #000000;"
                >
                  Margery E. Yuill Cancer Centre (Medicine Hat)
                </option>
                <option
                  value="Mary Immaculate Care Centre                                 "
                  style="color: #000000;"
                >
                  Mary Immaculate Care Centre
                </option>
                <option
                  value="Mayerthorpe Health Care Centre                              "
                  style="color: #000000;"
                >
                  Mayerthorpe Health Care Centre
                </option>
                <option
                  value="Mazankowski Alberta Heart Institute                         "
                  style="color: #000000;"
                >
                  Mazankowski Alberta Heart Institute
                </option>
                <option
                  value="Mental Health Clinics across Northern Alberta               "
                  style="color: #000000;"
                >
                  Mental Health Clinics across Northern Alberta
                </option>
                <option
                  value="Mental Health Foundation                                    "
                  style="color: #000000;"
                >
                  Mental Health Foundation
                </option>
                <option
                  value="Misericordia Hospital                                       "
                  style="color: #000000;"
                >
                  Misericordia Hospital
                </option>
                <option
                  value="Nanton Community Health Centre                              "
                  style="color: #000000;"
                >
                  Nanton Community Health Centre
                </option>
                <option
                  value="North East Community Health Centre                          "
                  style="color: #000000;"
                >
                  North East Community Health Centre
                </option>
                <option
                  value="Northern Alberta                                            "
                  style="color: #000000;"
                >
                  Northern Alberta
                </option>
                <option
                  value="Northern Lights Regional Health Centre                      "
                  style="color: #000000;"
                >
                  Northern Lights Regional Health Centre
                </option>
                <option
                  value="Oilfields General Hospital (Black Diamond)                  "
                  style="color: #000000;"
                >
                  Oilfields General Hospital (Black Diamond)
                </option>
                <option
                  value="Okotoks Health &amp; Wellness Centre                            "
                  style="color: #000000;"
                >
                  Okotoks Health &amp; Wellness Centre
                </option>
                <option
                  value="Our Lady of the Rosary Hospital                             "
                  style="color: #000000;"
                >
                  Our Lady of the Rosary Hospital
                </option>
                <option
                  value="Oyen Community Health Services                              "
                  style="color: #000000;"
                >
                  Oyen Community Health Services
                </option>
                <option
                  value="Peace River Community Cancer Centre                         "
                  style="color: #000000;"
                >
                  Peace River Community Cancer Centre
                </option>
                <option
                  value="Peace River Community Health Centre                         "
                  style="color: #000000;"
                >
                  Peace River Community Health Centre
                </option>
                <option
                  value="Peter Lougheed Centre                                       "
                  style="color: #000000;"
                >
                  Peter Lougheed Centre
                </option>
                <option
                  value="Pincher Creek Health Centre                                 "
                  style="color: #000000;"
                >
                  Pincher Creek Health Centre
                </option>
                <option
                  value="Ponoka Community Health Centre                              "
                  style="color: #000000;"
                >
                  Ponoka Community Health Centre
                </option>
                <option
                  value="Ponoka Hospital &amp; Care Centre                               "
                  style="color: #000000;"
                >
                  Ponoka Hospital &amp; Care Centre
                </option>
                <option
                  value="Queen Elizabeth II Hospital                                 "
                  style="color: #000000;"
                >
                  Queen Elizabeth II Hospital
                </option>
                <option
                  value="Regional EMS Foundation                                     "
                  style="color: #000000;"
                >
                  Regional EMS Foundation
                </option>
                <option
                  value="Rocky Mountain House Health Centre                          "
                  style="color: #000000;"
                >
                  Rocky Mountain House Health Centre
                </option>
                <option
                  value="Rockyview General Hospital                                  "
                  style="color: #000000;"
                >
                  Rockyview General Hospital
                </option>
                <option
                  value="Royal Alexandra Hospital                                    "
                  style="color: #000000;"
                >
                  Royal Alexandra Hospital
                </option>
                <option
                  value="Sherritt Health Services Centre                             "
                  style="color: #000000;"
                >
                  Sherritt Health Services Centre
                </option>
                <option
                  value="Silver Willow Lodge - DAL Unit (Nanton)                     "
                  style="color: #000000;"
                >
                  Silver Willow Lodge - DAL Unit (Nanton)
                </option>
                <option
                  value="South Health Campus                                         "
                  style="color: #000000;"
                >
                  South Health Campus
                </option>
                <option
                  value="Southern Alberta                                            "
                  style="color: #000000;"
                >
                  Southern Alberta
                </option>
                <option
                  value="St. Joseph&#39;s Auxiliary Hospital                             "
                  style="color: #000000;"
                >
                  St. Joseph&#39;s Auxiliary Hospital
                </option>
                <option
                  value="St. Joseph&#39;s General Hospital (Vegreville)                  "
                  style="color: #000000;"
                >
                  St. Joseph&#39;s General Hospital (Vegreville)
                </option>
                <option
                  value="St. Joseph&#39;s Home (Medicine Hat)                            "
                  style="color: #000000;"
                >
                  St. Joseph&#39;s Home (Medicine Hat)
                </option>
                <option
                  value="St. Mary&#39;s Health Care Centre                               "
                  style="color: #000000;"
                >
                  St. Mary&#39;s Health Care Centre
                </option>
                <option
                  value="St. Mary&#39;s Hospital (Camrose)                               "
                  style="color: #000000;"
                >
                  St. Mary&#39;s Hospital (Camrose)
                </option>
                <option
                  value="St. Michael&#39;s Health Centre (Lethbridge)                    "
                  style="color: #000000;"
                >
                  St. Michael&#39;s Health Centre (Lethbridge)
                </option>
                <option
                  value="St. Therese Villa (Lethbridge)                              "
                  style="color: #000000;"
                >
                  St. Therese Villa (Lethbridge)
                </option>
                <option
                  value="Stettler Hospital &amp; Care Centre                             "
                  style="color: #000000;"
                >
                  Stettler Hospital &amp; Care Centre
                </option>
                <option
                  value="Stollery Children&#39;s Hospital                                "
                  style="color: #000000;"
                >
                  Stollery Children&#39;s Hospital
                </option>
                <option
                  value="Strathcona Community Hospital                               "
                  style="color: #000000;"
                >
                  Strathcona Community Hospital
                </option>
                <option
                  value="Strathmore Hospital                                         "
                  style="color: #000000;"
                >
                  Strathmore Hospital
                </option>
                <option
                  value="Sturgeon Community Hospital                                 "
                  style="color: #000000;"
                >
                  Sturgeon Community Hospital
                </option>
                <option
                  value="Swan Hills Healthcare Centre                                "
                  style="color: #000000;"
                >
                  Swan Hills Healthcare Centre
                </option>
                <option
                  value="Sylvan Lake Urgent Care                                     "
                  style="color: #000000;"
                >
                  Sylvan Lake Urgent Care
                </option>
                <option
                  value="Taber Health Centre                                         "
                  style="color: #000000;"
                >
                  Taber Health Centre
                </option>
                <option
                  value="Taber Health Foundation - Greatest needs                    "
                  style="color: #000000;"
                >
                  Taber Health Foundation - Greatest needs
                </option>
                <option
                  value="The University of Alberta Hospital                          "
                  style="color: #000000;"
                >
                  The University of Alberta Hospital
                </option>
                <option
                  value="Thickwood Public Health Clinic                              "
                  style="color: #000000;"
                >
                  Thickwood Public Health Clinic
                </option>
                <option
                  value="Thorsby Public Health Centre                                "
                  style="color: #000000;"
                >
                  Thorsby Public Health Centre
                </option>
                <option
                  value="Three Hills Health Centre                                   "
                  style="color: #000000;"
                >
                  Three Hills Health Centre
                </option>
                <option
                  value="Tofield Health Centre                                       "
                  style="color: #000000;"
                >
                  Tofield Health Centre
                </option>
                <option
                  value="Tom Baker Cancer Centre                                     "
                  style="color: #000000;"
                >
                  Tom Baker Cancer Centre
                </option>
                <option
                  value="Two Hills Health Centre                                     "
                  style="color: #000000;"
                >
                  Two Hills Health Centre
                </option>
                <option
                  value="Villa Caritas                                               "
                  style="color: #000000;"
                >
                  Villa Caritas
                </option>
                <option
                  value="Vulcan Community Health Centre                              "
                  style="color: #000000;"
                >
                  Vulcan Community Health Centre
                </option>
                <option
                  value="Wainwright Health Centre                                    "
                  style="color: #000000;"
                >
                  Wainwright Health Centre
                </option>
                <option
                  value="Westview Health Centre                                      "
                  style="color: #000000;"
                >
                  Westview Health Centre
                </option>
                <option
                  value="Willow Creek Continuing Care Centre                         "
                  style="color: #000000;"
                >
                  Willow Creek Continuing Care Centre
                </option>
                <option
                  value="Worsley Community Health Services                           "
                  style="color: #000000;"
                >
                  Worsley Community Health Services
                </option>
                <option
                  value="Youville Home (St. Albert)                                  "
                  style="color: #000000;"
                >
                  Youville Home (St. Albert)
                </option>
              </select>
              <div
                id="DIField_18526_f_NewDesignation_errors"
                class="DialogInsightErrorContainer"
              />
            </div>
          </div>
          <template
            v-if="
              (mobilePhone.length === 0 || mobilePhone.length === 10) &&
                (homePhone.length === 0 || homePhone.length === 10)
            "
          >
            <div class="DialogInsightFormSubmit">
              <input
                type="submit"
                value="Create My Account"
                onclick="DI.Forms.Optin.Client.GetOptinForm('DIForm_709_18526').Submit(this); return false;"
              >
            </div>
          </template>
          <template v-else>
            <div class="invalid-button">
              <input
                type="submit"
                value="Enter a Valid Phone Number"
                class="bg-red-400 hover:bg-red-800"
                disabled
              >
            </div>
          </template>
          <div
            class="
            disclaimer
            w-full
            px-4
            py-8
            sm:w-1/2 sm:py-12 sm:mx-auto
            text-sm
          "
          >
            <div class="mb-4">
              The personal information collected by WinWin Staff Lottery will be
              used by the Lottery and participating Foundations to process
              ticket orders, notify winners, send out lottery information in
              2022 and future years, and to contact you regarding marketing and
              fundraising efforts, research, promotional information and events,
              through email, phone or mail.
            </div>
            <div class="mb-4">
              Prize winners’ name, ticket numbers, city and facility designation
              will be posted at winwinstafflottery.ca and on promotional
              materials and/or emails.
            </div>
            <div class="mb-4">
              Should you have any concerns about how we collect, use or disclose
              your personal information, please contact us by email at
              <a
                href="mailto:customerservice@winwinstafflottery.ca"
                class="winwin-aqua"
              >customerservice@winwinstafflottery.ca</a>
              or call
              <a
                href="tel:+18445946946"
                class="winwin-aqua"
              >1 (844) 594 - 6946</a>.
            </div>
          </div>
        </div>

        <div
          id="divForm_DIForm_709_18526_success"
          class="DialogInsightFormSuccessDiv"
          style="padding: 10px; display: none"
        >
          <div v-if="loading === false && timer === false">
            <div class="text-2xl winwin-gold1 mb-4">
              Thank you for your support
              <span class="capitalize" />!
            </div>
            <div class="pb-2">
              You have successfully enrolled in the WinWin Staff Lottery, and
              you should receive a confirmation email shortly.
            </div>
            <div class="pb-2">
              If you do not receive your confirmation email, please check you
              junk/spam folder or contact us at
              <a
                href="mailto:customerservice@winwinstafflottery.ca"
                class="winwin-aqua"
              >customerservice@winwinstafflottery.ca</a>
            </div>
            <div class="text-2xl pb-2">
              Stay tuned each month to find out if you're a winner!
            </div>
            <div class="pb-2 capitalize text-sm">
              Payroll deductions will begin on the next available pay period
              provided AHS payroll is able to validate your employee ID.
            </div>
            <CustomButton @click="loadUser()">
              VIEW MY PROFILE
            </CustomButton>
          </div>
          <div v-if="loading === true">
            <div class="text-xl my-6">
              Please wait while your profile is being built...
            </div>
            <Loading />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import { onMounted } from "@vue/runtime-core";

	import CustomButton from "@/components/CustomButton";
	import Loading from "@/components/Loading";

	export default {
		name: "OptinFormTickets",
		components: {
			CustomButton,
			Loading,
		},
		props: ["user"],
		setup() {
			onMounted(() => {
				// ClickSpace form requirement
				DI.Forms.Optin.Dom.onReady(function() {
					DI.Forms.Optin.Client.InitOptinForm({
						formIdent: "DIForm_709_18526",
						culture: "en-US",
						idBaseDiv: "divForm_DIForm_709_18526",
						recaptchaSiteKey: "",
						fields: [
							{
								name: "f_NewMainTicketPackage",
								lbl: "Select Your New Main Ticket Package",
								id: "DIField_18526_f_NewMainTicketPackage",
								validators: ["required"],
								inputType: "radio",
							},
							{
								name: "f_New5050TicketPackage",
								lbl: "Select Your New 50/50 Ticket Package",
								id: "DIField_18526_f_New5050TicketPackage",
								validators: [],
								inputType: "radio",
							},
							{
								name: "f_EmployeeID",
								lbl: "Employee ID",
								id: "DIField_18526_f_EmployeeID",
								validators: ["required"],
							},
							{
								name: "f_FirstName",
								lbl: "First Name",
								id: "DIField_18526_f_FirstName",
								validators: [],
							},
							{
								name: "f_LastName",
								lbl: "Last Name",
								id: "DIField_18526_f_LastName",
								validators: [],
							},
							{
								name: "f_HomeAddress",
								lbl: "HomeAddress",
								id: "DIField_18526_f_HomeAddress",
								validators: ["required"],
							},
							{
								name: "f_City",
								lbl: "City",
								id: "DIField_18526_f_City",
								validators: ["required"],
							},
							{
								name: "f_PostalCode",
								lbl: "Postal code",
								id: "DIField_18526_f_PostalCode",
								validators: ["required"],
							},
							{
								name: "f_MobilePhone",
								lbl: "Mobile phone",
								id: "DIField_18526_f_MobilePhone",
								validators: [],
							},
							{
								name: "f_HomePhone",
								lbl: "Home phone",
								id: "DIField_18526_f_HomePhone",
								validators: [],
							},
							{
								name: "f_EMail",
								lbl: "EMail",
								id: "DIField_18526_f_EMail",
								validators: ["required", "email"],
							},
							{
								name: "f_AlternateEmail",
								lbl: "Alternate Email",
								id: "DIField_18526_f_AlternateEmail",
								validators: ["email"],
							},
							{
								name: "f_PayrollSelection",
								lbl: "Payroll Selection",
								id: "DIField_18526_f_PayrollSelection",
								validators: ["required"],
								inputType: "radio",
							},
							{
								name: "f_NewDesignation",
								lbl: "Select Your New Designation",
								id: "DIField_18526_f_NewDesignation",
								validators: [],
								inputType: "select",
							},
						],
						fieldValues: {},
						errorMessages: {
							general: "Error in form.",
							required: "The field {0} is required.",
							dataType: "The datatype for {0} is invalid.",
							min: "The minimum value for {0} is {1}.",
							max: "The maximum value for {0} is {1}.",
							interval: "The value for {0} must be between {1} and {2}.",
							inputMask: "The value for {0} does not match the input format.",
							updateDupeKey:
								"Update could not be performed as this identifier already exists.",
							checkInlineErrors: "Please correct the errors below.",
						},
						idSuccessDiv: "divForm_DIForm_709_18526_success",
						mode: DI.Forms.Optin.Client.EnumOptinMode.Optin,
						url: "//app.dialoginsight.com/A/WF.ashx",
						idWorkflow: 15231,
						wfKey: "wTD0v2",
						nodeKey: "Optin",
						visible: true,
					});
				});
			});
		},
		data() {
			return {
				loading: false,
				timer: false,
				mobilePhone: '',
				homePhone: ''
			};
		},
		methods: {
			loadUser() {
				// load user on action after delaying 5 seconds for ClickSpace webhook/API communication
				this.loading = true;
				setTimeout(() => {
					this.timer = true;
					this.loading = false;
					return (window.location.href = "/user");
				}, 5000);
			},
			maxChange: function() {
				this.mainPackage = 40;
				this.fiftyPackage = 35;
			},
			highFive: function() {
				this.mainPackage = 30;
				this.fiftyPackage = 25;
			},
			bigFour: function() {
				this.mainPackage = 30;
				this.fiftyPackage = 10;
			},
			easyTwenty: function() {
				this.mainPackage = 10;
				this.fiftyPackage = 10;
			},
			quickPick: function() {
				this.mainPackage = 5;
				this.fiftyPackage = 5;
			},
		},
	};
</script>
<style lang="scss">
	@import "../assets/styles.scss";

	.package-cont {
		width: 100px;
		height: 100px;
		margin: 0 auto;
	}
	.package-image {
		width: 100%;
		height: auto;
	}
</style>
